<template>
    <a :href="`https://wa.me/${this.elemWch}`" class="whatsapp-float" target="_blank" rel="noopener noreferrer" title="Contacta por WhatsApp">
        <ion-icon name="logo-whatsapp"></ion-icon>
    </a>
</template>

<script>
export default {
    name: 'WhatsAppFloat',
    data(){
        return{
            elemWch: ""
        }
    },
    async mounted(){
        try {
            const response = await fetch('/watchapp.json')
            const data = await response.json()
            this.elemWch = data.numero
        } catch (error) {
            console.error('Error cargando número de WhatsApp:', error)
            // Mantener el valor por defecto
        }
    }
}
</script>

<style scoped>

</style>